import { MantineProvider } from '@mantine/core';

export const DarkThemeProvider = ({ children }: { children: React.ReactNode }) => (
    <MantineProvider theme={{ colorScheme: 'dark' }} inherit>
        {children}
    </MantineProvider>
);
